<template>
  <div id="app">
    <router-view />
    <notifications
      group="userActivity"
      :duration="3000"
      :width="width"
      classes="vue-notification"
      position="center top"
      animation-type="velocity"
      :animation="animation"
    >
      <template slot="body" slot-scope="props">
        <v-card
          v-bind:class="
            $vuetify.dark
              ? 'honey-notification-card-dark ' + props.item.type
              : 'honey-notification-card-light ' + props.item.type
          "
        >
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs10 md11>
                <v-flex xs12>
                  <div class="body-2 text-lg-left">{{ props.item.title }}</div>
                </v-flex>
                <v-flex xs12>
                  <div
                    :class="
                      $vuetify.dark
                        ? 'caption text-lg-left grey--text text--lighten-3'
                        : 'caption text-lg-left grey--text text--darken-3'
                    "
                  >
                    {{ props.item.text }}
                  </div>
                </v-flex>
              </v-flex>
              <v-flex xs2 md1>
                <v-btn flat icon @click="props.close">
                  <v-icon>cancel</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </template>
    </notifications>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'App',
  data: function() {
    return {
      width: (window.innerWidth * 40) / 100,
      animation: {
        enter(element) {
          let height = element.clientHeight

          return {
            height: [height, 0]
          }
        },
        leave: {
          height: 0,
          opacity: 0
        }
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.session.user
    })
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.honey-notification-card-dark {
  margin: 0 5px 10px;
  padding: 2px;
  font-size: 13px;
  text-align: center;
  color: #fff !important;
  background-color: #303030 !important;
  border: 1px solid;
  border-left: 20px solid #187fe7;
  border-radius: 10px !important;
}

.honey-notification-card-dark .warning {
  border-color: #f48a06 !important;
}

.honey-notification-card-dark .info {
  border-color: #187fe7 !important;
}

.honey-notification-card-dark .error {
  border-color: #b82e24 !important;
}

.honey-notification-card-dark .success {
  border-color: #42a85f !important;
}

.honey-notification-card-light {
  margin: 0 5px 10px;
  padding: 2px;
  font-size: 13px;
  text-align: center;
  color: #303030 !important;
  background-color: #fafafa !important;
  border: 1px solid;
  border-left: 20px solid #187fe7;
  border-radius: 10px !important;
}

.honey-notification-card-light .warning {
  border-color: #f48a06 !important;
}

.honey-notification-card-light .info {
  border-color: #187fe7 !important;
}

.honey-notification-card-light .error {
  border-color: #b82e24 !important;
}

.honey-notification-card-light .success {
  border-color: #42a85f !important;
}

.vue-notification {
  margin: 0 5px 5px;

  font-size: 13px;
  text-align: center;
  /*background-color: #424242 !important;*/
  border-left: 12px solid #187fe7;
  border-radius: 10px !important;

  &.warn {
    border-color: #f48a06 !important;
  }

  &.info {
    border-color: #187fe7 !important;
  }

  &.error {
    border-color: #b82e24 !important;
  }

  &.success {
    border-color: #42a85f !important;
  }
}
</style>
